export default __webpack_public_path__ + "static/media/notin~WmrcmIgr.01607adf.svg";